<div *ngIf="user?.factorsList?.length > 0">
    <h3 class="title">Multi-factor authentication</h3>
    <p *ngIf="isCurrentUser">Enhance security with MFA. Your last used method is suggested by default. You can switch to another method anytime. SMS and authenticator apps supported.</p>

    <div *ngFor="let item of user?.factorsList" class="mfa-factor"
         [ngClass]="{'mfa-factor-active': item.enabled}"
         fxLayout="row" fxLayoutAlign="space-around center"
    >
        <mat-icon class="mfa-factor-icon" *ngIf="userMfaConfigSettings[item.name]?.icon">{{userMfaConfigSettings[item.name]?.icon}}</mat-icon>

        <div class="mfa-factor-content" fxLayout="column" fxLayoutAlign="center start">
            <div class="mfa-factor-header" fxLayout="row" fxLayoutAlign="space-between center">
                <h4>{{userMfaConfigSettings[item.name]?.friendlyName || item.name}}</h4>
                <div class="mfa-factor-actions">
                    <button *ngIf="item.enabled && isCurrentUser"
                            mat-button
                            color="primary"
                            (click)="onEditMfa(item)"
                    >Edit</button>

                    <mat-slide-toggle
                        class="example-margin"
                        aria-label="Enable or disable {{userMfaConfigSettings[item.name]?.friendlyName || item.name}}"
                        color="primary"
                        [checked]="item.enabled"
                        [disabled]="!item.enabled && !isCurrentUser"
                        (click)="onChangeMfaFactor($event, item)"
                    >
                    </mat-slide-toggle>
                </div>
            </div>
            <div class="mfa-factor-description" *ngIf="userMfaConfigSettings[item.name]?.description">
                {{userMfaConfigSettings[item.name]?.description}}
            </div>
            <div class="mfa-factor-extra secondary-text" *ngIf="item.enabled && item?.phone">
                Phone: ***{{item.phone | slice:-3}}
            </div>
        </div>
    </div>
</div>
